import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function PortalShell({ children, role }) {
  const { user, logout } = useAuth();
  const isAdmin = role === "admin";
  const base = isAdmin ? "/admin" : "/espace-client";
  const location = useLocation();

  const links = isAdmin
    ? [
        { to: "/admin", label: "Dashboard", icon: "fa-solid fa-gauge" },
        { to: "/admin/devis", label: "Demandes devis", icon: "fa-solid fa-file-signature" },
        { to: "/admin/contacts", label: "Messages contact", icon: "fa-solid fa-inbox" },
        { to: "/admin/chantiers", label: "Chantiers", icon: "fa-solid fa-helmet-safety" },
        { to: "/compte/mot-de-passe", label: "Mot de passe", icon: "fa-solid fa-key" },
      ]
    : [
        { to: "/espace-client", label: "Mes chantiers", icon: "fa-solid fa-helmet-safety" },
        { to: "/compte/mot-de-passe", label: "Mot de passe", icon: "fa-solid fa-key" },
      ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white flex" data-testid="portal-shell">
      {/* Sidebar */}
      <aside className="hidden md:flex flex-col w-64 bg-[#0d0d0d] border-r border-white/5">
        <Link to="/" className="flex items-center gap-3 px-6 h-20 border-b border-white/5">
          <img src="/assets/logo.png" alt="DCR-BATI" className="h-12 w-auto" />
          <div className="text-[9px] font-mono-tech tracking-widest text-neutral-500 uppercase">{isAdmin ? "Admin" : "Portail client"}</div>
        </Link>
        <nav className="flex-1 py-6 px-3 space-y-1" data-testid="portal-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end
              data-testid={`portal-link-${l.label}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-3 font-display uppercase text-sm tracking-wider transition-colors ${
                  isActive ? "bg-[#ffd600] text-black" : "text-neutral-300 hover:bg-white/5 hover:text-white"
                }`
              }
            >
              <i className={l.icon} /> {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/5">
          <div className="font-mono-tech text-[10px] uppercase tracking-widest text-neutral-500">Connecté en tant que</div>
          <div className="font-display uppercase truncate mt-1">{user?.name || "Utilisateur"}</div>
          <div className="text-neutral-400 text-xs truncate">{user?.email}</div>
          <button onClick={logout} className="mt-3 w-full btn-ghost !py-2 !px-3 !text-xs justify-center" data-testid="portal-logout">
            <i className="fa-solid fa-right-from-bracket" /> Déconnexion
          </button>
        </div>
      </aside>

      <main className="flex-1 min-w-0">
        {/* Top bar mobile */}
        <header className="md:hidden flex items-center justify-between px-5 h-16 border-b border-white/5 bg-[#0d0d0d]">
          <Link to="/" className="flex items-center gap-2">
            <img src="/assets/logo.png" alt="DCR-BATI" className="h-10 w-auto" />
          </Link>
          <button onClick={logout} className="btn-ghost !py-2 !px-3 !text-xs" data-testid="portal-logout-mobile">
            <i className="fa-solid fa-right-from-bracket" />
          </button>
        </header>
        <div className="p-6 md:p-10">{children}</div>
      </main>
    </div>
  );
}
